import React from 'react'
import './PhonereloadEzBillView.scss'

import CONFIG from '../../../../config'

import {getLanguageScope, N, createLazyExecution} from '../../../../helpers'
const _i18n = getLanguageScope('phonereload_ez_bill');

import Amount from '../../shared/Amounts/containers/AmountContainer'
import Navigation from '../../shared/Navigation/containers/NavigationContainer'

import {Grid, Header, Form, Input, Dropdown} from 'semantic-ui-react'
import {validator, FIELDS} from "../../PhonereloadEzBill/models/transaction";

class PhonereloadEzBill extends React.Component {
  constructor(props){
    super(props);

    this.lazyUpdateAmounts = createLazyExecution(async function (amount) {
      await props.appSetServerVal('original_amount', N(amount));
      await props.appCall('updateAmounts')
    }, 555)

    this.submitTransaction = this.submitTransaction.bind(this);
    this.changeRecipientNumber = this.changeRecipientNumber.bind(this);
  }

  updateAmount(amount) {
    const {appSetVal, customer_limit_amount} = this.props;
    if (amount > customer_limit_amount) return;

    appSetVal('display_amount', amount);

    this.lazyUpdateAmounts(amount)
  }

  changeRecipientNumber(value){
    const {appSetObj} = this.props;
    appSetObj({
      recipient_number: value,
      recipient_number_error: false
    })
  }

  submitTransaction() {
    this.changeRecipientNumber(this.props.phone_number);

    const extraFields = [FIELDS.recipient_number, FIELDS.required_PIN];
    
    this.props.submitTransaction(extraFields);
  }

  render(){

    const {ready_to_submit, checkFields, icon, title, required_PIN, phone_error_type, appSetVal, denominations, require_pin} = this.props;

    const extraFields = [];
    if (this.props.require_pin) extraFields.push(FIELDS.required_PIN);

    return (
      <Grid columns='equal'>

        <Grid.Row style={{'minHeight': 250}} stretched columns={2}>
          <Grid.Column>
            <Grid.Row column={1}>
              <Grid.Column>
                <Header image={`${CONFIG.STATIC_PATH}${icon}`} content={title} as='h3'/>
                <Form>
                  {require_pin && (
                    <Form.Field required={require_pin}>
                      <label>{_i18n('pin')}</label>
                      <Input name={'required_PIN'} value={required_PIN}
                             onChange={(e, {name, value}) => appSetVal(name, value)}
                             maxLength={4} placeholder={_i18n('enter_pin')}/>
                    </Form.Field>
                  )}
                  {denominations ? <Form.Field required>
                    <Header as='label' floated='left'>
                      {_i18n('select_amount')}
                    </Header>

                    <Dropdown
                      search
                      searchInput={{ type: 'number' }}
                      selection
                      onChange={(e, {name, value}) => this.updateAmount(value)}
                      options={denominations}
                      placeholder={_i18n('select_amount')}
                    />
                  </Form.Field> : null}

                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid.Column>

          <Grid.Column>
            <Grid.Row columns={1}>
              <Grid.Column>
                <Amount hideAmountInput={!!denominations} productPhoneMask phoneDoubleCheck/>
              </Grid.Column>
            </Grid.Row>
          </Grid.Column>
        </Grid.Row>

        <Navigation
          onSubmit={this.submitTransaction}
          showSubmit={true}
          disabledSubmit={ready_to_submit}
          submitValidator={() => checkFields(validator, extraFields)}
          showError={phone_error_type}
          messageError={phone_error_type ? _i18n(phone_error_type) : _i18n('invalid_number')}
        />

      </Grid>
    )
  }
}

export default PhonereloadEzBill


// WEBPACK FOOTER //
// ./src/components/Applications/PhonereloadEzBill/components/PhonereloadEzBillView.js